module.exports = __webpack_public_path__ + "static/media/img_features_05.1e795bc0.jpg";